<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
        class="table-style"
        stripe
        highlight-hover-row
        show-footer
        show-overflow
        max-height="540"
        border="none"
        :loading="loading"
        :data="collectionListData"
        :auto-resize="true"
        :filter-config="{ remote: true }"
        align="center"
        :footer-method="footerMethod"
        @cell-click="cellClick"
        ref="xTable"
        resizable
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
          field="paymentsNum"
          title="收付款编号"
          class-name="link-text"
      ></vxe-table-column>
      <vxe-table-column field="flowNum" title="流程编号" v-if="isHavePermission('twoPayments:flowNumPay')">
        <template slot-scope="{ row }">
          <span
              @click="openProcedureDetailTwo(row.flowId, 2)"
              style="color: #2d8cf0; cursor: pointer"
          >{{ row.flowNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="clientName"
          title="客户名称"
          :filters="filterclientName"
      ></vxe-table-column>
      <vxe-table-column field="addTime" title="日期"></vxe-table-column>
      <vxe-table-column field="note" title="摘要"></vxe-table-column>
      <vxe-table-column field="debiteAmount" title="借方金额（已付）">
        <template slot-scope="{ row }">
          <span>{{ row.debiteAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="creditAmount" title="贷方金额（应付）">
        <template slot-scope="{ row }">
          <span>{{ row.creditAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="balanceAmount" title="余额">
        <template slot-scope="{ row }">
          <span>{{ row.balanceAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-modal v-model="isShowCollectionDetail" width="1300" height="680" resize remember>
      <div slot="title">收付款详情</div>
      <collection-detail
          cate="Collection"
          :isShow="isShowCollectionDetail"
          ref="collectionDetail"
          @close="isShowCollectionDetail = false"
      ></collection-detail>
    </vxe-modal>
    <vxe-modal v-model="isShowPaymentDetail" width="1300" height="680" resize remember>
      <div slot="title">收付款详情</div>
      <payment-detail
          cate="Payment"
          :isShow="isShowPaymentDetail"
          ref="paymentDetail"
          @close="isShowPaymentDetail = false"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
        v-model="receivingDeailModal"
        width="1300"
        height="700"
        position="center"
        title="结算信息"
        showFooter
    >
      <receiving-detail ref="receivingDetail"></receiving-detail>
      <div slot="footer">
        <vxe-button
            type="submit"
            status="primary"
            @click="delReceiving(editRows)"
            v-if="isHavePermission('twoSettlement:delete') && editRows  && editRows.isCanDelete === 1"
            style="width: 140px; border-radius: 0px"
        >删除
        </vxe-button>
        <vxe-button
            type="submit"
            status="primary"
            @click="editReceiving(editRows)"
            v-if="isHavePermission('twoSettlement:update')"
            style="width: 140px; border-radius: 0px; margin-left: 10px"
        >编辑
        </vxe-button>
      </div>
    </vxe-modal>
    <edit-receiving ref="editReceiving" @updateList="updateList"></edit-receiving>
    <vxe-modal
        v-model="isShowCarryOverDetail"
        title="结转详情"
        width="1300"
        height="460"
        resize
        remember
    >
      <carry-over-detail
          :isShow="isShowCarryOverDetail"
          ref="carryOverDetail"
          @close="isShowCarryOverDetail = false"
      ></carry-over-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {timeFormatDate} from "@/filters/time";
import PaymentDetail from "@/views/payment2.0/PaymentDetail.vue";
import {
  goReceiveGoods,
  paymentFooter,
  getFilterObj,
  showLoading,
  hideLoading,
} from "@/utils/util";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import openProcedureDetailTwo from "@/mixin/viewOrderDetail";
import EditReceiving from "@/components/order2.0/Receiving/EditReceiving";
import BuyerReceivingDetail from "@/components/order2.0/Receiving/ReceivingDetail";
import CarryOverDetail from "@/views/payment2.0/CarryOverDetail.vue";
import CollectionDetail from "@/views/payment2.0/CollectionDetail.vue";
import ReceivingDetail from "@/components/order2.0/Receiving/ReceivingDetail";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {
    PaymentDetail,
    CarryOverDetail,
    CollectionDetail,
    ReceivingDetail,
    EditReceiving,
  },
  props: ["id", "pageTab"],
  mixins: [getAuthOrization, openProcedureDetailTwo],
  data() {
    return {
      loading: false,
      collectionListData: [],
      editRows: null,
      isShowSellerReceivingDetail: false,
      receivingDeailModal: false,
      isShowCollectionDetail: false,
      isShowPaymentDetail: false,
      isShowCarryOverDetail: false,
      filterclientName: [],
    };
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getCollectionListData();
    //   }
    // },
    pageTab() {
      this.pageTab === 5 ? this.getCollectionListData() : "";
    },
  },
  // activated() {
  //   // this.getCollectionListData();
  //   this.$bus.$on("allOrderDetailRenovate", (data) => {
  //     data === true ? this.getCollectionListData() : "";
  //   });
  // },
  methods: {
    delReceiving(row) {
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.deleteCommit(row);
        }
      });
    },
    async deleteCommit(row) {
      var idList = [];
      idList.push(row.id);
      showLoading();
      let res = await $api.twoSettlement.request("delete", {
        idList: idList,
      });
      hideLoading();
      if (res.status == 1) {
        // this.listQuery.page = 1;
        // this.currentPage = 1;
        this.getCollectionListData();
        this.receivingDeailModal = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    init() {
      this.getCollectionListData();
    },
    editReceiving(row) {
      this.receivingDeailModal = false;
      this.$refs.editReceiving.editReceiving(row);
    },
    updateList(val) {
      if (val) {
        this.receivingDeailModal = false;
        this.init();
      }
    },
    // footerMethod() {},
    async getCollectionListData() {
      this.filterclientName = [];
      this.loading = true;
      let res = await $api.paymentsTwo.request("queryPaymentsPayList", {
        ordersId: this.id,
        orderBy: 3,
        isDesc: 0,
        ordersVersion: 2
      });
      if (res.status === 1) {
        let collectionListData = res.data.rows;
        const xTable = this.$refs.xTable;
        const ownNameColumn = xTable.getColumnByField("ownName");
        const clientNameColumn = xTable.getColumnByField("clientName");
        collectionListData.map((i) => {
          getFilterObj(this.filterclientName, i.clientName);
          i.addTime = timeFormatDate(i.addTime);
          if (i.paymentsState === 1) {
            i.paymentsNum = i.receiveNum;
          }
        });
        xTable.setFilter(clientNameColumn, this.filterclientName);
        xTable.updateData();
        this.collectionListData = collectionListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    footerMethod({columns, data}) {
      return paymentFooter({columns, data});
    },
    viewCarryOverDetail(id) {
      this.isShowCarryOverDetail = true;
      this.$refs.carryOverDetail.initDetail(id);
    },
    cellClick(e) {
      let field = e.column.property;
      let row = e.row;
      if (field === "paymentsNum") {
        if (e.row.sourceType === 6) {
          // 打开结转流程
          this.viewCarryOverDetail(e.row.id);
        } else {
          if (e.row.sourceType == 2) {
            if (!this.isHavePermission("PaymentsBuyer2.0")) {
              this.$Message["info"]({
                background: true,
                content: "对不起，您没有该权限！",
              });
              return;
            }
            this.viewDetail(e.row);
          }
          if (e.row.sourceType == 3) {
            if (!this.isHavePermission("PaymentsSeller2.0")) {
              this.$Message["info"]({
                background: true,
                content: "对不起，您没有该权限！",
              });
              return;
            }
            this.viewPaymentDetail(e.row);
          } else {
            if (e.row.sourceType == 1) {
              if (!this.isHavePermission("twoSettlement:detail")) {
                this.$Message["info"]({
                  background: true,
                  content: "对不起，您没有该权限！",
                });
                return;
              }
              this.receivingDeailModal = true;
              this.editRows = {
                id: e.row.id,
                isCanDelete: e.row.isCanDelete
              };
              this.$refs.receivingDetail.getReceivingDetail({
                id: e.row.id,
              });
            }
            if (e.row.sourceType == 7) {
              if (e.row.paymentsNum.charAt(0) == "P") {
                if (!this.isHavePermission("PaymentsSeller2.0")) {
                  this.$Message["info"]({
                    background: true,
                    content: "对不起，您没有该权限！",
                  });
                  return;
                }
                this.viewPaymentDetail(e.row);
              } else if (e.row.paymentsNum.charAt(0) == "I") {
                if (!this.isHavePermission("PaymentsBuyer2.0")) {
                  this.$Message["info"]({
                    background: true,
                    content: "对不起，您没有该权限！",
                  });
                  return;
                }
                this.viewDetail(e.row);
              }
            }
          }
        }
      }
    },
    viewDetail(row) {
      this.isShowCollectionDetail = true;
      this.$refs.collectionDetail.setEdit(false);
      this.$refs.collectionDetail.init(row.id);
    },
    viewPaymentDetail(row) {
      this.isShowPaymentDetail = true;
      this.$refs.paymentDetail.setEdit(false);
      this.$refs.paymentDetail.init(row.id);
    },
  },
};
</script>

<style></style>
